export default __webpack_public_path__ + "static/digital_print2-4f031e738b84f1e3b2f5a51148832bd3.jpg";